import React, { useEffect, useId, useState } from "react";

export default function CoffeePeriod({ form, setForm }) {
  const [mode, setMode] = useState(() =>
    form.from === form.until && !form.fromTime && !form.untilTime
      ? "single"
      : "range"
  );
  useEffect(() => {
    if (mode === "range" && (form.fromTime == null || form.untilTime == null)) {
      setForm((old) => ({
        ...old,
        fromTime: old.fromTime ?? "00:00",
        untilTime: old.untilTime ?? "23:59",
      }));
    }
  }, [mode, form.fromTime, form.untilTime, setForm]);
  const groupId = useId();
  const change = (key, value) => setForm((old) => ({ ...old, [key]: value }));
  const selectMode = (value) => {
    setMode(value);
    if (value === "single")
      setForm((old) => ({
        ...old,
        until: old.from,
        fromTime: null,
        untilTime: null,
      }));
  };
  return (
    <section>
      <h2>Período del registro</h2>
      <fieldset className="coffee-period-choice">
        <legend>Tipo de fecha</legend>
        <label>
          <input
            type="radio"
            name={groupId}
            value="single"
            checked={mode === "single"}
            onChange={() => selectMode("single")}
          />
          Una fecha
        </label>
        <label>
          <input
            type="radio"
            name={groupId}
            value="range"
            checked={mode === "range"}
            onChange={() => selectMode("range")}
          />
          Rango de fechas
        </label>
      </fieldset>
      <div className="coffee-grid coffee-period-fields">
        {mode === "single" ? (
          <label>
            Fecha *
            <input
              type="date"
              required
              value={form.from}
              onChange={(e) => {
                const date = e.target.value;
                setForm((old) => ({ ...old, from: date, until: date }));
              }}
            />
          </label>
        ) : (
          <>
            <label>
              Desde *
              <input
                type="date"
                required
                value={form.from}
                max={form.until || undefined}
                onChange={(e) => change("from", e.target.value)}
              />
            </label>
            <label>
              Hora desde *
              <input
                type="time"
                step="60"
                required
                value={form.fromTime ?? "00:00"}
                max={
                  form.from === form.until
                    ? form.untilTime || undefined
                    : undefined
                }
                onChange={(e) => change("fromTime", e.target.value)}
              />
            </label>
            <label>
              Hasta (cierre) *
              <input
                type="date"
                required
                value={form.until}
                min={form.from || undefined}
                onChange={(e) => change("until", e.target.value)}
              />
            </label>
            <label>
              Hora hasta *
              <input
                type="time"
                step="60"
                required
                value={form.untilTime ?? "23:59"}
                min={
                  form.from === form.until
                    ? form.fromTime || undefined
                    : undefined
                }
                onChange={(e) => change("untilTime", e.target.value)}
              />
            </label>
          </>
        )}
      </div>
      <p className="coffee-hint">
        {mode === "single"
          ? "Los datos corresponden a la fecha seleccionada."
          : "Horario de Panamá (24 horas). Los datos corresponden al período completo seleccionado."}
      </p>
    </section>
  );
}
